import { render, staticRenderFns } from "./PartnerSuccessStories.vue?vue&type=template&id=643a60ce"
import script from "./PartnerSuccessStories.vue?vue&type=script&lang=js"
export * from "./PartnerSuccessStories.vue?vue&type=script&lang=js"
import style0 from "./PartnerSuccessStories.vue?vue&type=style&index=0&id=643a60ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports